import Chai from "chai"
import App from "@fae/source/models/App.js"
import Dev from "@fae/source/models/dev/Dev.js"
import games from "@fae/source/data/games/index.js"
import savetests from "@fae/source/data/games/savetests.js"

const tests = [
    {"key": "add", "func": () => Chai.expect(4).to.equal(4)},
    {"key": "divide", "func": () => Chai.expect(2 / 2).to.equal(1)},
    {"key": "multiply", "func": () => Chai.expect(2 * 3).to.equal(6)},
    {"key": "remainder", "func": () => Chai.expect(2 % 3).to.equal(2)},
    {"key": "subtract", "func": () => Chai.expect(2 - 3).to.equal(-1)},
    {"key": "rightshift", "func": () => Chai.expect(2 >> 3).to.equal(0)},
    {"key": "leftshift", "func": () => Chai.expect(2 << 3).to.equal(16)},
    {"key": "leftshift", "func": () => Chai.expect(2 ** 3).to.equal(8)},
]

// tests.push({"key": "savetests", "func": () => Chai.expect(doSavetestsClear(savetests)).to.equal(true)})
// function doSavetestsClear(tests) {
//     Dev.inProtoMode = false
//     Object.values(tests).forEach((test) => {
//         if(test.status == undefined) {
//             test.isLoading = true
//             const game = games[test.gameSlug]
//             const chapter = game.chapters[test.chapterSlug]
//             App.load({"game": {...game, chapter}})
//             test.status = Dev.replaySavestate(test) ? "good" : "bad"
//             test.isLoading = false
//         }
//     })
//     return Object.values(tests).every((test) => test.status == "good")
// }

// var context = require.context("@fae/source/tests", false, /.test.js$/)
// const tests2 = context.keys().map((key) => {
//     const tests = context(key)
//     tests = tests.concat(tests)
//     return tests
// })

// window.fae = window.fae || {}
// window.fae.tests = window.fae.tests || tests

export default tests






import Geometry from "@fae/source/utility/Geometry.js"

tests.push({
    "key": "Geometry.roundToWholeNumber",
    "func": () => Chai.expect(Geometry.roundToWholeNumber({"x": 0.33, "y": 0.66})).to.deep.equal({"x": 0, "y": 0})
})
tests.push({
    "key": "Geometry.toString",
    "func": () => Chai.expect(Geometry.toString({"x": 5, "y": 3, "z": 1})).to.equal("5x3x1")
})
tests.push({
    "key": "Geometry.toString",
    "description": "no z coordinate",
    "func": () => Chai.expect(Geometry.toString({"x": 5, "y": 3})).to.equal("5x3")
})


import Delta from "@fae/source/models/Delta.js"

tests.push({
    "key": "Delta.editUnit",
    "func": () => {
        return Chai.expect(Delta.editUnit(
            {"key": "a", "name": "A", "position": {"x": 6, "y": 9}},
            {"key": "a", "name": null, "position": {"x": -3}, "color": "blue"}
        )).to.deep.equal(
            {"key": "a", "position": {"x": -3, "y": 9}, "color": "blue"}
        )
    }
})

tests.push({
    "key": "Delta.editStage",
    "func": () => {
        return Chai.expect(Delta.editStage(
            {
                "units": {
                    "a": {"key": "a", "name": "A", "position": {"x": 6, "y": 9}},
                }
            },
            {
                "units": {
                    "a": {"key": "a", "name": null, "position": {"x": -3}, "color": "blue"}
                }
            },
        )).to.deep.equal(
            {
                "units": {
                    "a": {"key": "a", "position": {"x": -3, "y": 9}, "color": "blue"}
                }
            }
        )
    }
})
